const ALLOWED_MODES = new Set(['safe', 'smart', 'aggressive']);

export function resolveOnboardingMessageMode() {
  const fromStorage = String(localStorage.getItem('bbtv_onboarding_message_mode') || '').trim().toLowerCase();
  if (ALLOWED_MODES.has(fromStorage)) return fromStorage;

  const fromEnv = String(process.env.REACT_APP_ONBOARDING_MESSAGE_MODE || '').trim().toLowerCase();
  if (ALLOWED_MODES.has(fromEnv)) return fromEnv;

  return 'smart';
}

export function pickMessageByMode(mode, variants) {
  const normalized = ALLOWED_MODES.has(mode) ? mode : 'smart';
  if (variants && typeof variants === 'object' && variants[normalized]) return variants[normalized];
  return variants?.smart || variants?.safe || variants?.aggressive || '';
}

